import { useState } from "react";
import api from "../services/api";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            setMessage("");

            await api.post("/accounts/forgot-password", { email });

            setMessage("If this email exists, a reset link has been sent.");
        } catch {
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="crm-login-page">
            <form className="crm-login-card" onSubmit={handleSubmit}>
                <h2>Forgot Password</h2>

                {message && <div className="crm-alert success">{message}</div>}

                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <button type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Send Reset Link"}
                </button>
            </form>
        </div>
    );
}